import React from "react";
import { Button, Stack, Typography, styled } from "@mui/material";
import ContactUIFunctional from "./ContactUIFunctional";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";
import Chip from '../../../components/ui/Chip';
const StyledButton = styled(Button)({
    backgroundColor: '#376AFA',
	textTransform: 'unset',
	padding:'6px 5px 6px 10px',
	borderRadius:'7px',
    '&:hover': {
        backgroundColor: '#114ef5'
    }
})

const WithdrawlButton = styled(Button)({
    backgroundColor: '#fff', 
    border: '1px solid #376AFA'
})

const SelectedContactFunctional = (props) => {
	const { contact, requestSent, spinner, sending, index, userDomain, showStatus = false } = props;

    const RequestButton = () => {
		if (!requestSent && !spinner) {
			return (
				<StyledButton variant="contained" onClick={() => props.sendTheRequest(contact.userId, index)}>
					<Typography className={`${userDomain}_font`} style={{ color: "#fff", fontSize: "14px", textTransform: 'unset' }}>
						Send Request 
					</Typography>
                    <KeyboardArrowRightOutlined />
				</StyledButton>
			);
		}

		if (spinner && sending) {
			return (
				<img
					loading="lazy"
					width="25px"
					style={{ position: "absolute", right: "30px" }}
					src="/img/tx-loading.gif"
					alt="spinner"
				/>
			);
		}
		if (requestSent && !spinner) {
			return (
                    <Typography className={`${userDomain}_font`} sx={{ color: "#376AFA", fontSize: "16px" }}>Request Sent</Typography>
			);
		}
	};

	const ShowStatus = () => {
		if (contact?.showAcceptIgnoreMsg) {
			return <Chip label="Requested" color='success' sx={{ backgroundColor: '#05BC52' }} />
		} else if (contact?.waitingForConfirmation) {
			return <Typography sx={{ fontSize: '14px', textAlign: 'center', color: '#8387BD' }}>Awaiting confirmation</Typography>
		}	
	}

	return (
		<Stack flexDirection='row'
			justifyContent="space-between"
			alignItems="center"
			onClick={() => props.handleSelectContact && props.handleSelectContact(contact)}
			sx={{ position: "relative", width: '100%', cursor: 'pointer', backgroundColor: props.selectedUserId === contact.userId ? '#F3F3FA' : 'inherit', padding: '8px', borderRadius: '8px' }}
		>
			<ContactUIFunctional
				showRanks={true}
				contact={contact}
				userId={contact.userId}
				allProfileImages={props.allProfileImages}
				userDomain={userDomain}
			/>
            {!showStatus && <RequestButton />}
			{showStatus && <ShowStatus />}
		</Stack>
	);
};

export default SelectedContactFunctional;
